/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Insales } from '../models/Insales';
import type { InsalesAdd } from '../models/InsalesAdd';
import type { InsalesList } from '../models/InsalesList';
import type { InsalesProduct } from '../models/InsalesProduct';
import type { InsalesProductList } from '../models/InsalesProductList';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InsalesService {
    /**
     * Get insales
     * @returns InsalesList OK
     * @throws ApiError
     */
    public static getInsales(): CancelablePromise<InsalesList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/insales',
        });
    }
    /**
     * Add insales
     * @param requestBody Add insales data
     * @returns Insales OK
     * @throws ApiError
     */
    public static addInsales(
        requestBody?: InsalesAdd,
    ): CancelablePromise<Insales> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/insales',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get insales by id
     * @param id insales_id
     * @returns Insales OK
     * @throws ApiError
     */
    public static getInsaleById(
        id: number,
    ): CancelablePromise<Insales> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/insales/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Delete insales by id
     * @param id insales_id
     * @returns InsalesAdd OK
     * @throws ApiError
     */
    public static deleteInsaleById(
        id: number,
    ): CancelablePromise<InsalesAdd> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/insales/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update insales by id
     * @param id insales_id
     * @param requestBody Update insales data
     * @returns Insales OK
     * @throws ApiError
     */
    public static updateInsaleById(
        id: number,
        requestBody?: InsalesAdd,
    ): CancelablePromise<Insales> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/insales/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get products by id
     * @param id insales_id
     * @returns InsalesProductList OK
     * @throws ApiError
     */
    public static getInsalesProductsByInsalesId(
        id: number,
    ): CancelablePromise<InsalesProductList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/insales/{id}/products',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Get products by id
     * @param id insales_id
     * @param product product_id
     * @returns InsalesProduct OK
     * @throws ApiError
     */
    public static getInsalesProductsById(
        id: number,
        product: number,
    ): CancelablePromise<InsalesProduct> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/insales/{id}/products/{product}',
            path: {
                'id': id,
                'product': product,
            },
        });
    }
}
